export type ClubAccent = "amber" | "indigo" | "moss" | "ink" | "rose";

const ACCENTS: ClubAccent[] = ["amber", "indigo", "moss", "ink", "rose"];

export function clubAccent(clubId: string): ClubAccent {
  let hash = 0;
  for (let i = 0; i < clubId.length; i += 1) {
    hash = (hash * 31 + clubId.charCodeAt(i)) >>> 0;
  }
  return ACCENTS[hash % ACCENTS.length];
}

export function clubInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "—";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}
